export default {
  // Input Titles
  transferDirection: "Transfer Direction",
  currencyToken: "Currency/Token Contract",
  tags: "Tags",
  functionSwitch: "Function Switch",
  time: "Time",

  // Placeholders
  pleaseSelect: "Please Select",
  startDate: "Start Date",
  endDate: "End Date",

  // Buttons and Links
  transactionQuantityConfig: "Transaction Quantity Config",
  moreFilters: "More Filters",
  cancel: "Cancel",
  confirm: "Confirm",

  // Transfer Direction Options
  outflow: "Outflow",
  inflow: "Inflow",
  bidirectional: "Bidirectional",

  // Function Switch Options
  surveyData: "Survey Data",
  surveyDataTooltip: "Can expand uploaded survey related data",
  firstInflow: "First Inflow",
  firstInflowTooltip: "Expand to display first main coin inflow address",
  swapContract: "Swap Contract",
  swapContractTooltip: "Can expand swap contract transaction data",

  // Currency Categories
  commonCurrency: "Common Currency",
  contractToken: "Contract Token",
  all: "All",

  // Message Prompts
  currencyUpdateSuccess: "Currency updated successfully",
  timeUpdateSuccess: "Time updated successfully",
  tagUpdateSuccess: "Tag updated successfully",
  switchUpdateSuccess: "Switch updated successfully",
  directionUpdateSuccess: "Transfer direction updated successfully!",
  filterSuccess: "Filter successful",

  // Data Prompts
  noDataFound:
    "No data matching the search content found. Please correct and try again",

  // Tag Tooltips
  exchangeAddressTooltip:
    "Extended addresses only show exchange-related tagged addresses",
  maliciousAddressTooltip:
    "Extended addresses only show malicious tagged addresses",
};
